(function initInfiniteScroll() {
  var productGrid = document.querySelector('.js-product-listing');
  if (!productGrid) return;
  productGrid = productGrid.parentElement;

  var loading = false;
  var currentNextUrl = null;

  var style = document.createElement('style');
  style.textContent = '#pagination { display: none !important; }';
  document.head.appendChild(style);

  function getNextUrl() {
    var next = document.querySelector('.paginate_next');
    return next ? next.getAttribute('href') : null;
  }

  function removePagination() {
    var p = document.querySelector('#pagination');
    if (p) p.parentNode.removeChild(p);
  }

  function loadMore() {
    var nextUrl = getNextUrl();
    if (!nextUrl || loading || nextUrl === currentNextUrl) return;

    loading = true;
    currentNextUrl = nextUrl;
    removePagination();

    fetch(nextUrl).then(function(res) {
      return res.text();
    }).then(function(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newProducts = doc.querySelectorAll('.js-product-listing');
      for (var i = 0; i < newProducts.length; i++) {
        productGrid.appendChild(newProducts[i]);
      }
      var newPagination = doc.querySelector('#pagination');
      if (newPagination) {
        productGrid.parentNode.appendChild(newPagination);
      }
      loading = false;
    });
  }

  window.addEventListener('scroll', function() {
    var scrolledTo = window.scrollY + window.innerHeight;
    var threshold = document.body.offsetHeight - 400;
    if (scrolledTo >= threshold) loadMore();
  });
})();
